export default __webpack_public_path__ + "static/image-list-2eed89d28f6f17603847a1946c18e5d5.png";